<template>
  <div class="mv-arow" :class="{ 'is-sel': selected, 'is-cut': isCut }" :title="assetTooltip(asset)" :draggable="canEdit" @dragstart="onDragStart" @click="play()">
    <div style="position: relative; width: 72px; height: 40px; flex: none; border-radius: 5px; overflow: hidden; background: var(--bg)">
      <v-img contain :src="$store.state.getThumbUrl(asset.id, asset.thumbnail)" height="40" width="72" />
    </div>
    <div style="flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 4px">
      <div ellipsis style="font-size: 13px; font-weight: 600; color: var(--text)">{{ assetTitle(asset) }}</div>
      <div class="mono" ellipsis style="font-size: 10px; color: var(--text-faint)">{{ tagLine }}</div>
    </div>
    <span v-if="showsStatus" class="pill" :style="pillStyle(state.color)" :title="state.detail"><span class="pill-dot"></span>{{ state.label }}</span>
    <span class="mono" style="flex: none; width: 86px; text-align: right; font-size: 11px; color: var(--text-dim)">{{ durationTc }}</span>
    <button
      type="button"
      class="mv-rowadd"
      :class="{ 'is-on': whole }"
      :title="$store.state.cartToggleTitle(asset.id)"
      @click.stop="$store.state.toggleWholeAsset(asset)">
      {{ whole ? "✓" : "+" }}
    </button>
  </div>
</template>

<script>
import { assetState, showsStatus, pillStyle } from "@/scripts/assetStatus";
import { toTc } from "@/scripts/timecode.js";
import { whenVisible, stopWatching } from "@/scripts/media.js";
import { assetTitle, assetTooltip, assetTags, TAG_SEPARATOR } from "@/scripts/assetLabels.js";

export default {
  props: {
    asset: { type: Object, required: true },
  },
  data: () => {
    return {
      seen: false,
    };
  },
  computed: {
    selected() {
      return this.$store.state.currentClip.id === this.asset.id;
    },
    canEdit() {
      return this.$store.state.canEdit(this.asset);
    },
    isCut() {
      return this.$store.state.cutAssets.some((a) => a.id === this.asset.id);
    },
    /** The asset's whole-asset entry in the active cart, which + adds and ✓ removes. */
    whole() {
      return !!this.$store.state.wholeClipOf(this.asset.id);
    },
    state() {
      return assetState(this.asset);
    },
    showsStatus() {
      return showsStatus(this.asset);
    },
    durationTc() {
      const secs = this.$store.state.durationOf(this.asset.id);
      return secs ? toTc(secs) : "";
    },
    // A new status key (upload, processing, ready) asks again, so a row that turns ready gets its length.
    probeKey() {
      return this.seen ? this.asset.id + ":" + this.state.key : "";
    },
    tagLine() {
      return assetTags(this.asset).join(TAG_SEPARATOR);
    },
  },
  methods: {
    assetTitle,
    assetTooltip,
    pillStyle,
    play() {
      this.$store.state.playClip(this.asset);
    },
    onDragStart(e) {
      e.dataTransfer.setData("assetID", this.asset.id);
      e.dataTransfer.effectAllowed = "move";
    },
  },
  watch: {
    probeKey(key) {
      if (key) this.$store.state.requestDuration(this.asset);
    },
  },
  // ponytail: seen stays true after the first sighting, so each status key is probed once.
  mounted() {
    whenVisible(this.$el, () => (this.seen = true));
  },
  beforeDestroy() {
    stopWatching(this.$el);
  },
};
</script>
